import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../../../../graphql-types'

const defaultOptions = {} as const
export type PlaylistGenerateSubscriptionSubscriptionVariables = Types.Exact<{
  input: Types.OracleAgentChatInput;
}>;

export type PlaylistGenerateSubscriptionSubscription = { __typename?: 'Subscription', oracleAgentChat: { __typename?: 'OracleAgentChatSubscriptionPayload', chatSessionId?: string | null, chatChannel?: string | null, textChunk?: string | null, isFinal: boolean, success: boolean, errors: Array<string>, documents?: Array<{ __typename?: 'OracleDocument', componentId: string, contentId: number, title: string, contentType: string, path: string, content?: { __typename?: 'Content', id?: string | null, contentId?: number | null, path?: string | null, title?: string | null, contentType?: string | null, contentAssetReferences?: Array<{ __typename?: 'ContentAssetReference', asset?: { __typename?: 'Asset', renderUrl?: string | null, language?: string | null } | null } | null> | null, featureMedia?: { __typename?: 'Media', mediaId?: string | null } | null } | null }> | null, errorInfo: Array<{ __typename?: 'AppError', code: string, message: string }>, rateLimitStatus?: { __typename?: 'RateLimitInfo', totalInteractions: number, remainingInteractions: number, rateLimited: boolean } | null } };

export type PlaylistSaveMutationVariables = Types.Exact<{
  input: Types.OraclePlaylistSaveInput;
}>;

export type PlaylistSaveMutation = { __typename?: 'Mutation', oraclePlaylistSave: { __typename?: 'OraclePlaylistSaveResponse', success: boolean, errors: Array<string>, playlistId?: string | null, playlistName?: string | null, itemsAdded: number } };

export type AlchemizeSeedQuestionListQueryVariables = Types.Exact<{ [key: string]: never; }>;

export type AlchemizeSeedQuestionListQuery = { __typename?: 'Query', featureSeedQuestionList: { __typename?: 'SeedQuestionListResponse', seedQuestions: Array<{ __typename?: 'SeedQuestion', id: string, question: string, tags: Array<string> }> } };

export const PlaylistGenerateSubscriptionDocument = gql`
    subscription PlaylistGenerateSubscription($input: OracleAgentChatInput!) {
  oracleAgentChat(input: $input) {
    chatSessionId
    chatChannel
    textChunk
    documents {
      componentId
      contentId
      title
      contentType
      path
      content {
        id
        contentId
        path
        title
        contentType
        contentAssetReferences(contentAssetReferences: [{type: "d6-keyart-with-text"}]) {
          asset {
            renderUrl
            language
          }
        }
        featureMedia {
          mediaId
        }
      }
    }
    isFinal
    success
    errors
    errorInfo {
      code
      message
    }
    rateLimitStatus {
      totalInteractions
      remainingInteractions
      rateLimited
    }
  }
}
    `

/**
 * __usePlaylistGenerateSubscriptionSubscription__
 *
 * To run a query within a React component, call `usePlaylistGenerateSubscriptionSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlaylistGenerateSubscriptionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaylistGenerateSubscriptionSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlaylistGenerateSubscriptionSubscription (baseOptions: Apollo.SubscriptionHookOptions<PlaylistGenerateSubscriptionSubscription, PlaylistGenerateSubscriptionSubscriptionVariables> & ({ variables: PlaylistGenerateSubscriptionSubscriptionVariables; skip?: boolean; } | { skip: boolean; })) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<PlaylistGenerateSubscriptionSubscription, PlaylistGenerateSubscriptionSubscriptionVariables>(PlaylistGenerateSubscriptionDocument, options)
}
export type PlaylistGenerateSubscriptionSubscriptionHookResult = ReturnType<typeof usePlaylistGenerateSubscriptionSubscription>;
export type PlaylistGenerateSubscriptionSubscriptionResult = Apollo.SubscriptionResult<PlaylistGenerateSubscriptionSubscription>;
export const PlaylistSaveDocument = gql`
    mutation PlaylistSave($input: OraclePlaylistSaveInput!) {
  oraclePlaylistSave(input: $input) {
    success
    errors
    playlistId
    playlistName
    itemsAdded
  }
}
    `
export type PlaylistSaveMutationFn = Apollo.MutationFunction<PlaylistSaveMutation, PlaylistSaveMutationVariables>;

/**
 * __usePlaylistSaveMutation__
 *
 * To run a mutation, you first call `usePlaylistSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaylistSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [playlistSaveMutation, { data, loading, error }] = usePlaylistSaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlaylistSaveMutation (baseOptions?: Apollo.MutationHookOptions<PlaylistSaveMutation, PlaylistSaveMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<PlaylistSaveMutation, PlaylistSaveMutationVariables>(PlaylistSaveDocument, options)
}
export type PlaylistSaveMutationHookResult = ReturnType<typeof usePlaylistSaveMutation>;
export type PlaylistSaveMutationResult = Apollo.MutationResult<PlaylistSaveMutation>;
export type PlaylistSaveMutationOptions = Apollo.BaseMutationOptions<PlaylistSaveMutation, PlaylistSaveMutationVariables>;
export const AlchemizeSeedQuestionListDocument = gql`
    query AlchemizeSeedQuestionList {
  featureSeedQuestionList(
    feature: ALCHEMIZE
    limit: 6
    distributedCategories: [PRACTICE_YOGA, PRACTICE_MEDITATION, PRACTICE_BREATHWORK, NON_PRACTICE]
  ) {
    seedQuestions {
      id
      question
      tags
    }
  }
}
    `

/**
 * __useAlchemizeSeedQuestionListQuery__
 *
 * To run a query within a React component, call `useAlchemizeSeedQuestionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlchemizeSeedQuestionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlchemizeSeedQuestionListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAlchemizeSeedQuestionListQuery (baseOptions?: Apollo.QueryHookOptions<AlchemizeSeedQuestionListQuery, AlchemizeSeedQuestionListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AlchemizeSeedQuestionListQuery, AlchemizeSeedQuestionListQueryVariables>(AlchemizeSeedQuestionListDocument, options)
}
export function useAlchemizeSeedQuestionListLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<AlchemizeSeedQuestionListQuery, AlchemizeSeedQuestionListQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AlchemizeSeedQuestionListQuery, AlchemizeSeedQuestionListQueryVariables>(AlchemizeSeedQuestionListDocument, options)
}
export function useAlchemizeSeedQuestionListSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AlchemizeSeedQuestionListQuery, AlchemizeSeedQuestionListQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AlchemizeSeedQuestionListQuery, AlchemizeSeedQuestionListQueryVariables>(AlchemizeSeedQuestionListDocument, options)
}
export type AlchemizeSeedQuestionListQueryHookResult = ReturnType<typeof useAlchemizeSeedQuestionListQuery>;
export type AlchemizeSeedQuestionListLazyQueryHookResult = ReturnType<typeof useAlchemizeSeedQuestionListLazyQuery>;
export type AlchemizeSeedQuestionListSuspenseQueryHookResult = ReturnType<typeof useAlchemizeSeedQuestionListSuspenseQuery>;
export type AlchemizeSeedQuestionListQueryResult = Apollo.QueryResult<AlchemizeSeedQuestionListQuery, AlchemizeSeedQuestionListQueryVariables>;
